import alphaNumericValidation, { IFSCCodereg, MobileNumberreg, emailRegex } from '../../util/regex'

const handleStateError = (func: any) => {
  func('')
  return true
}

export const checkInputAndShowError = (
  value?: string,
  type?: string,
  selectedFilteredData?: any,
  setContactError?: (val: string) => void,
  setEmailError?: (val: string) => void,
  setAmountError?: (val: string) => void,
  setInvoiceError?: (val: string) => void,
  setMerchantLinkError?: (val: string) => void,
  setPaymentLinkError?: (val: string) => void,
) => {
  const contact = type === 'contact'
  const email = type === 'email'
  const amount = type === 'amount'
  const invoiceNumber = type === 'invoiceNumber'
  const merchantLinkId = type === 'merchantLinkId'
  const paymentLinkId = type === 'paymentLinkId'
  if (value && value?.length > 0 && contact && selectedFilteredData?.contact?.length > 0) {
    const pattern = new RegExp(/^[0-9\b]+$/)
    if (!pattern.test(value)) {
      setContactError && setContactError('Please enter valid phone number.')
      return true
    } else if (value && value?.length !== 10) {
      setContactError && setContactError('Please enter 10 digit phone number.')
      return true
    } else {
      handleStateError(setContactError)
    }
  } else if (contact && value?.length === 0) {
    handleStateError(setContactError)
  }
  if (value && value?.length > 2 && email) {
    const pattern = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/
    if (pattern.test(value) === false) {
      setEmailError && setEmailError('Please enter valid email id')
      return true
    } else {
      setEmailError && setEmailError('')
      return true
    }
  } else if (email && value?.length === 0) {
    handleStateError(setEmailError)
  }

  if (value && value?.length > 0 && amount) {
    const pattern = new RegExp(/^\d+(\.\d{1,2})?$/)
    if (!pattern.test(value)) {
      setAmountError && setAmountError('Please enter valid input.')
      return true
    } else {
      setAmountError && setAmountError('')
      return true
    }
  } else if (amount && value?.length === 0) {
    handleStateError(setAmountError)
  }

  if (value && value?.length > 0 && invoiceNumber) {
    const pattern = new RegExp(/[a-zA-Z0-9]{2,}/)
    if (!pattern.test(value)) {
      setInvoiceError && setInvoiceError('Please enter valid input.')
      return true
    } else {
      setInvoiceError && setInvoiceError('')
      return true
    }
  } else if (invoiceNumber && value?.length === 0) {
    handleStateError(setInvoiceError)
  }

  if (value && value?.length > 0 && merchantLinkId) {
    const pattern = new RegExp(/[a-zA-Z0-9]{2,}/)
    if (!pattern.test(value)) {
      setMerchantLinkError && setMerchantLinkError('Please enter valid input.')
      return true
    } else {
      setMerchantLinkError && setMerchantLinkError('')
      return true
    }
  } else if (merchantLinkId && value?.length === 0) {
    handleStateError(setMerchantLinkError)
  }

  if (value && value?.length > 0 && paymentLinkId) {
    const pattern = new RegExp(/^[0-9\b]+$/)
    if (!pattern.test(value)) {
      setPaymentLinkError && setPaymentLinkError('Please enter valid input.')
      return true
    } else {
      setPaymentLinkError && setPaymentLinkError('')
      return true
    }
  } else if (paymentLinkId && value?.length === 0) {
    handleStateError(setPaymentLinkError)
  }
  return false
}

export const checkBeneficiaryInputAndShowError = (
  value?: string,
  type?: string,
  selectedFilteredData?: any,
  setBeneficiaryTypeError?: (val: string) => void,
  setBeneficiaryEmailError?: (val: string) => void,
  setBeneficiaryNameError?: (val: string) => void,
  setBeneficiaryIdError?: (val: string) => void,
  setBeneficiaryPhoneError?: (val: string) => void,
  setBeneficiaryIfscError?: (val: string) => void,
  setBeneficiaryAccNoError?: (val: string) => void,
  setBeneficiaryCardError?: (val: string) => void,
  setBeneficiaryUpiVpaError?: (val: string) => void,
) => {
  const beneficiaryType = type === 'beneficiaryType'
  const beneficiaryEmail = type === 'beneficiaryEmail'
  const beneficiaryName = type === 'beneficiaryName'
  const beneficiaryId = type === 'beneficiaryId'
  const beneficiaryPhone = type === 'beneficiaryPhoneNumber'

  if (value && value?.length > 0 && beneficiaryPhone && selectedFilteredData?.beneficiaryPhoneNumber?.length > 0) {
    const pattern = MobileNumberreg
    if (!pattern.test(value)) {
      setBeneficiaryPhoneError && setBeneficiaryPhoneError('Please enter valid phone number.')
      return true
    } else if (value && value?.length !== 10) {
      setBeneficiaryPhoneError && setBeneficiaryPhoneError('Please enter 10 digit phone number.')
      return true
    } else {
      handleStateError(setBeneficiaryPhoneError)
    }
  } else if (beneficiaryPhone && value?.length === 0) {
    handleStateError(setBeneficiaryPhoneError)
  }
  if (value && value?.length > 2 && beneficiaryEmail) {
    const pattern = emailRegex
    if (pattern.test(value) === false) {
      setBeneficiaryEmailError && setBeneficiaryEmailError('Please enter valid email id')
      return true
    } else {
      setBeneficiaryEmailError && setBeneficiaryEmailError('')
      return true
    }
  } else if (beneficiaryEmail && value?.length === 0) {
    handleStateError(setBeneficiaryEmailError)
  }

  if (value && value?.length > 0 && beneficiaryType) {
    const pattern = new RegExp(/^[A-Za-z\s]+$/)
    if (!pattern.test(value)) {
      setBeneficiaryTypeError && setBeneficiaryTypeError('Please enter valid input.')
      return true
    } else {
      setBeneficiaryTypeError && setBeneficiaryTypeError('')
      return true
    }
  } else if (beneficiaryType && value?.length === 0) {
    handleStateError(setBeneficiaryTypeError)
  }

  if (value && value?.length > 0 && beneficiaryName) {
    const pattern = new RegExp(/^[A-Za-z\s]+$/)
    if (!pattern.test(value)) {
      setBeneficiaryNameError && setBeneficiaryNameError('Please enter valid input.')
      return true
    } else {
      setBeneficiaryNameError && setBeneficiaryNameError('')
      return true
    }
  } else if (beneficiaryName && value?.length === 0) {
    handleStateError(setBeneficiaryNameError)
  }
  if (value && value?.length > 0 && beneficiaryId) {
    const pattern = alphaNumericValidation
    if (!pattern.test(value)) {
      setBeneficiaryIdError && setBeneficiaryIdError('Please enter valid input.')
      return true
    } else {
      setBeneficiaryIdError && setBeneficiaryIdError('')
      return true
    }
  } else if (beneficiaryId && value?.length === 0) {
    handleStateError(setBeneficiaryIdError)
  }
  if (value && value?.length > 0 && type === 'beneficiaryAccountNumber') {
    const pattern = new RegExp(/^[0-9\b]+$/)
    if (!pattern.test(value)) {
      setBeneficiaryAccNoError && setBeneficiaryAccNoError('Please enter valid account number.')
      return true
    } else {
      setBeneficiaryAccNoError && setBeneficiaryAccNoError('')
      return true
    }
  } else if (beneficiaryId && value?.length === 0) {
    handleStateError(setBeneficiaryAccNoError)
  }
  if (value && value?.length > 0 && type === 'beneficiaryCardNumber') {
    const pattern = new RegExp(/^[0-9\b]+$/)
    if (!pattern.test(value)) {
      setBeneficiaryCardError && setBeneficiaryCardError('Please enter card number.')
      return true
    } else {
      setBeneficiaryCardError && setBeneficiaryCardError('')
      return true
    }
  } else if (beneficiaryId && value?.length === 0) {
    handleStateError(setBeneficiaryCardError)
  }
  if (value && value?.length > 0 && type === 'beneficiaryIfsc') {
    const pattern = IFSCCodereg
    if (!pattern.test(value)) {
      setBeneficiaryIfscError && setBeneficiaryIfscError('Please enter valid ifsc.')
      return true
    } else {
      setBeneficiaryIfscError && setBeneficiaryIfscError('')
      return true
    }
  } else if (beneficiaryId && value?.length === 0) {
    handleStateError(setBeneficiaryIfscError)
  }
  if (value && value?.length > 0 && type === 'beneficiaryUpiVpa') {
    const pattern = alphaNumericValidation
    if (!pattern.test(value)) {
      setBeneficiaryUpiVpaError && setBeneficiaryUpiVpaError('Please enter valid vpa.')
      return true
    } else {
      setBeneficiaryUpiVpaError && setBeneficiaryUpiVpaError('')
      return true
    }
  } else if (beneficiaryId && value?.length === 0) {
    handleStateError(setBeneficiaryUpiVpaError)
  }
}
